import { Channel } from "@anycable/web";

export default class MapChannel extends Channel {
  static identifier = "Admins::MapChannel";

  receive(message) {
    if (message.position) {
      return this.handleTechnicianLocation(message);
    }

    // Fallback to the default behaviour
    super.receive(message);
  }

  handleTechnicianLocation(message) {
    // Emit custom event when message contains a location
    return this.emit("technician-location", message);
  }
}
